import { initJentisEvent } from "@onestore/jentis-datalayer"
import { setAffiliateCookie } from "@onestore/onestore-store-common/affiliate"
import { setReferrerInSessionStorage } from "@onestore/tacos"
import { VERSION } from "./src/index"
import { setCampaignPromoCode } from "./src/lib/campaignPromoCode"
import { getAffiliateCookieName } from "./src/lib/config"
import { initConsentManager } from "./src/lib/consentManager"
import { pushLocationChange } from "./src/lib/dataLayer"
import { scrollToAnchor } from "./src/lib/dom"
import { checkTokens } from "./src/lib/init"
import { disableKameleoon, initKameleoon, sendKameleoonPageView } from "./src/lib/kameleoon"
import { initMetrics } from "./src/lib/metrics"
import { initOaO, pushFrontendToken, pushPageView } from "./src/lib/oao"
import { resolvePageAnalytics } from "./src/lib/pageAnalytics"
import Storage from "./src/lib/storage"
import SessionStorage from "./src/lib/storage/SessionStorage"
import { initTacos } from "./src/lib/tacos"
import { initTracking } from "./src/lib/tracking"

// These scripts can be triggered multiple times during a single page visit
// If they need to run only once, they should be protected internally
initJentisEvent()
initConsentManager(initTacos, initOaO, initKameleoon, disableKameleoon)
initMetrics()
checkTokens()
initTracking()

setAffiliateCookie(getAffiliateCookieName())
setCampaignPromoCode()

window.onestoreContext = {}
window.dataLayer = window.dataLayer || []
window.__version = VERSION
window.__build = process.env.GATSBY_SITE_BUILD

export { default as wrapRootElement } from "~/wrappers/wrapRootElement"

export const onInitialClientRender = () => {
  const hash = window.location.hash

  if (hash) {
    scrollToAnchor(hash.replace("#", ""))
  }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  const prevPath = prevLocation ? prevLocation.href : null

  const pageAnalytics = resolvePageAnalytics(location.pathname)

  setReferrerInSessionStorage(prevPath)
  pushLocationChange(
    location.href,
    prevPath,
    location.pathname,
    pageAnalytics
  )
  pushPageView()
  pushFrontendToken()

  window.jentisDataLayer?.pushPageViewEvent({
    locationPath: location.href,
    prevPath: prevPath,
    userStatusAdblock: SessionStorage.get("_oab") !== "none",
    priceType: Storage.getLastPriceType() || "",
    page_type: null,
    article: null,
    application_name: pageAnalytics.applicationName,
    product_area: pageAnalytics.productArea,
    product_section: pageAnalytics.productSection,
  })

  if (prevLocation) {
    sendKameleoonPageView()
  }
}

export const onClientEntry = () => {
  if (process.env.NODE_ENV === "development") {
    const originalError = console.error

    console.error = (...args) => {
      if (
        /Support for defaultProps will be removed from function components in a future major release/.test(
          args[0]
        )
      ) {
        return
      }
      originalError.apply(console, args)
    }
  }
}
